export default "__VITE_ASSET__BST0NYw4__"